import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PaisService {
  // Usamos un CDN de confianza que aloja el listado ISO con nombres en español directo
  private apiUrl = 'https://raw.githubusercontent.com/mledoze/countries/master/countries.json';

  constructor(private http: HttpClient) { }

  getPaises(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      map(paises => 
        paises.map(p => {
          // Esta estructura viene con traducción directa de manera nativa en su esquema
          let nombreEnEspanol = '';
          
          if (p.translations && p.translations.spa && p.translations.spa.common) {
            nombreEnEspanol = p.translations.spa.common;
          } else {
            nombreEnEspanol = p.name && p.name.common ? p.name.common : 'SIN NOMBRE';
          }

          return {
            name: nombreEnEspanol.toUpperCase(),
            code: p.cca2 // Código de 2 dígitos (MX, US, etc.)
          };
        })
        // Ordenar alfabéticamente de la A a la Z
        .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/services/pais.services.ts